module.exports = __webpack_public_path__ + "static/img/posPicture.b06e2fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technology/posPicture.jpg
// module id = 094d
// module chunks = 0